import { AbstractVirtualManifestBuilderWithActionableSlots } from './AbstractVirtualManifestBuilderWithActionableSlots';

export class MergeVirtualManifestBuilder extends AbstractVirtualManifestBuilderWithActionableSlots {
  reduceManifestEntity: AbstractVirtualManifestBuilderWithActionableSlots['reduceManifestEntity'] =
    (manifestProp, left, right, mappings) => {
      const valueA = left.value;
      const valueB = right.value;
      const mergedValue = { ...valueA, ...valueB };
      const mergedMappings = { ...mappings };

      if (valueB) {
        const keys = Object.keys(valueB);

        for (const key of keys) {
          const existingMappings = mappings?.[key];
          const rightKeyMappings = right.mappings?.[key] ?? [];

          mergedMappings[key] = existingMappings
            ? [...existingMappings, ...rightKeyMappings]
            : [...rightKeyMappings];
        }
      }

      return {
        value: mergedValue,
        mappings: mergedMappings,
      };
    };
}
